import { styled } from '@mui/material/styles'

const getStyles = (theme) => (
  {
    root: {
      display: 'flex',
      position: 'relative',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'column',
      padding: 0,
      minHeight: 150,
      width: '100%',
      '&:before': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        height: 48,
        width: '100%',
        backgroundColor: theme.mode === 'dark' ? '#4c4c4c' : '#eaeaea'
      }
    },
    image: {
      height: 220,
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
      '&> img': {
        width: '100%',
        height: 220,
        objectFit: 'cover',
        borderRadius: '5px 5px 0 0',
        transition: 'transform .8s',
        position: 'absolute',
        top: 0,
        left: 0,
        '&:hover': {
          transform: 'scale(1.2)'
        }
      }
    },
    toolBarContent: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      borderTop: ' 4px solid rgb(255, 0, 0)'
    },
    iconsDetails: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-around'
    },
    bodyTitle: {
      color: 'gray',
      fontFamily: 'Bree Serif',
      fontWeight: 400
    },
    bodyContent: {
      color: 'gray'
    },
    detailsBtn: {
      marginBottom: 30,
      boxShadow: '3px 2px 4px -1px #0000008c'
    }
  }
)
const PREFIX = 'UnitStyle'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const UnitStyle = styled('div')(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  UnitStyle
}
